module.exports = __webpack_public_path__ + "static/media/hand-middle-finger.be303c13.svg";